<template>
  <div class="modalUploadPic">
    <div id="modalUploadPic" class="modal fade" data-backdrop="static">
      <div
        class="modal-dialog modal-dialog-vertical-center modal-lg"
        :class="mode == 1 ? 'modal-lg' : 'modal-md'"
      >
        <div class="modal-content bd-0 tx-14">
          <modal-loading :show="modalLoading"></modal-loading>
          <template v-if="mode == 1">
            <div v-if="loading" class="upload-loading-mask">
              <div class="upload-loading">
                <div class="upload-bar">
                  <div class="bar">
                    <div class="text">
                      {{ successNum }} / {{ uploadFiles.length }}
                    </div>
                    <div
                      class="bg"
                      :style="{
                        width: (successNum / uploadFiles.length) * 100 + '%',
                      }"
                    ></div>
                  </div>
                  <p v-if="uploadError">
                    {{ $t("outside.上传失败，") }}
                    <a
                      class="mg-r-15 tx-primary"
                      href="javascript:;"
                      @click="reUpload"
                      >{{ $t("outside.重试") }}</a
                    >
                    <a
                      class="mg-r-15 tx-danger"
                      href="javascript:;"
                      @click="cancelUPload"
                      >{{ $t("outside.取消") }}</a
                    >
                  </p>
                  <p v-else>{{ $t("outside.图片上传中, 请勿关闭当前窗口") }}</p>
                </div>
              </div>
            </div>
            <div class="modal-header pd-y-20 pd-x-25">
              <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
                {{ $t("outside.上传图片") }}
              </h6>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body pd-25 model-auto-h">
              <div v-if="!folder" class="row form-group tx-12 mg-b-10">
                <label class="col-2 col-form-label form-control-sm text-right">
                  {{ $t("outside.选择相册：") }}
                </label>
                <div class="col-6 row align-items-center">
                  <div class="col">
                    <select
                      class="form-control form-control-sm"
                      v-model="selectedId"
                    >
                      <option value="">{{ $t("outside.默认相册") }}</option>
                      <option
                        v-for="item in albumItems"
                        :key="item.id"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col">
                    {{ $t("outside.或") }}
                    <a
                      href="javascript:;"
                      class="tx-info"
                      @click="addAlbum()"
                      >{{ $t("outside.新建相册") }}</a
                    >
                  </div>
                </div>
              </div>
              <div v-else class="mg-b-5">
                {{ $t("outside.相册：")
                }}<span class="tx-gray-700">{{ folder }}</span>
              </div>
              <div class="row tx-12">
                <div class="col-7">
                  <div class="upload-wrap">
                    <template v-if="items.length">
                      <ul class="images-ul">
                        <li
                          v-for="item in items"
                          :key="item.key"
                          :class="{
                            disabled:
                              item.size > maxSize ||
                              !item.isImg ||
                              !item.checked,
                          }"
                        >
                          <label>
                            <input
                              v-if="item.size > maxSize || !item.isImg"
                              class="mg-r-5"
                              type="checkbox"
                              disabled
                            />
                            <input
                              v-else
                              class="mg-r-5"
                              type="checkbox"
                              v-model="item.checked"
                            />
                            <svg class="iconfont icons mg-r-5">
                              <use
                                :xlink:href="
                                  item.isImg
                                    ? '#icon-color-img'
                                    : '#icon-color-file'
                                "
                              ></use>
                            </svg>
                            <span class="name tx-ellipsis1 mg-r-5">{{
                              item.name
                            }}</span>
                            <span v-if="item.isImg" class="mg-r-5 tx-gray-600"
                              >({{ toMb(item.size) }} M)</span
                            >
                            <span v-if="!item.isImg" class="tx-danger">
                              {{ $t("outside.(不是图片)") }}
                            </span>
                            <span
                              v-if="item.isImg && item.size > maxSize"
                              class="tx-danger"
                            >
                              {{ $t("outside.(文件超过5MB)") }}
                            </span>
                          </label>
                        </li>
                      </ul>
                    </template>
                    <template v-else>
                      <button
                        type="button"
                        class="upload-btn btn btn-primary"
                        @click="uploadOpen()"
                      >
                        {{ $t("outside.选择上传图片文件") }}
                      </button>
                    </template>
                  </div>
                  <div v-if="items.length" class="aciton">
                    <div class="mg-b-10 tx-center">
                      <button
                        type="button"
                        class="upload-btn btn btn-primary"
                        @click="uploadOpen()"
                      >
                        {{ $t("outside.继续选择上传图片") }}
                      </button>
                    </div>
                    <div>
                      {{ $t("outside.已选择") }}
                      <span class="tx-primary">{{ imgLen }}</span>
                      {{ $t("outside.张图片。上传完成后，") }}
                      {{ $t("outside.图片将会占用") }}
                      <span class="tx-primary">{{ totalSize }}</span
                      >MB。
                    </div>
                    <div v-if="errorFilesLen" class="mg-b-10">
                      {{ $t("outside.不符合要求文件") }}
                      <span class="tx-danger">{{ errorFilesLen }}</span>
                      {{ $t("outside.个") }}
                    </div>
                  </div>
                </div>
                <div class="col-5">
                  <ol>
                    <li>
                      <h3>1.{{ $t("outside.上传规则：") }}</h3>
                      <p>
                        {{ $t("outside.每个相册最多上传") }}{{ maxUpload
                        }}{{ $t("outside.张图片") }}
                      </p>
                      <p>{{ $t("outside.单张最大5MB") }}</p>
                      <p>
                        {{
                          $t(
                            "outside.原始图片宽高超过1920像素时，系统会自动对图片进行等比例压缩"
                          )
                        }}
                      </p>
                    </li>
                    <li>
                      <h3>2.{{ $t("outside.支持格式：") }}</h3>
                      <p>
                        jpg,jpeg,bmp,png,gif
                        {{ $t("outside.(超过2M的gif图片将会丢失动画效果)") }}
                      </p>
                    </li>
                  </ol>
                  <div>
                    <div class="p-bar">
                      <p>
                        {{ $t("outside.您的相册空间享有") }} {{ maxSpace }}
                        {{ $t("outside.容量") }}
                      </p>
                      <div class="bar">
                        <span>{{ usingSpace }} MB / {{ maxSpace }} </span>
                        <div
                          class="bg"
                          :style="{
                            right:
                              usingSpace > maxSpace
                                ? 0
                                : 100 - (usingSpace / maxSpace) * 100 + '%',
                          }"
                        ></div>
                      </div>
                    </div>
                    <div class="mg-t-15" v-if="userInfo.setSupplierAlbum != 1">
                      <span class="tx-gray-900">{{
                        $t("outside.相册容量不够用？")
                      }}</span>
                      <a
                        href="javascript:;"
                        class="tx-info mg-l-15"
                        @click="openSet"
                        >{{ $t("outside.立即升级容量") }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <input
                type="file"
                id="uploadPic"
                multiple
                @change="fileChange($event)"
                ref="checkImg"
              />
            </div>
            <div class="modal-footer">
              <div class="d-flex justify-content-center">
                <template v-if="items.length">
                  <button
                    class="btn btn-primary mg-r-15"
                    type="button"
                    @click="uploadSubmit()"
                  >
                    {{ $t("outside.确认上传") }}
                  </button>
                  <button
                    class="btn btn-danger mg-r-30"
                    type="button"
                    @click="resetModal"
                  >
                    {{ $t("outside.清空") }}
                  </button>
                </template>
                <button
                  class="btn btn-secondary"
                  type="button"
                  data-dismiss="modal"
                >
                  {{ $t("outside.关闭") }}
                </button>
              </div>
            </div>
          </template>
          <template v-if="mode == 2">
            <div class="modal-header pd-y-20 pd-x-25 justify-content-start">
              <button
                class="back-upload mg-r-15"
                type="button"
                @click="backUpload()"
              >
                <span aria-hidden="true"
                  ><i class="fa fa-arrow-left" aria-hidden="true"></i
                ></span>
              </button>
              <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
                {{ $t("outside.新建相册") }}
              </h6>
            </div>
            <div class="modal-body pd-25 model-auto-h">
              <div class="form-group row align-items-center">
                <label
                  class="
                    col-md-2 col-sm-12 col-form-label
                    form-control-sm
                    text-right
                  "
                  >{{ $t("outside.相册名称：") }}</label
                >
                <div class="col-md-9 col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    v-model="createAlbum.name"
                  />
                </div>
              </div>
              <!--<div class="form-group row align-items-center">
              <label class="col-md-2 col-sm-12 col-form-label form-control-sm text-right">相册类型：</label>
              <div class="col-md-9 col-sm-12">
                <div class="form-check form-check-inline pd-r-15"  v-for="(q,w) in $dict.imgsType" :key="w">
                  <label class="rdiobox">
                    <input type="radio" name="types" :value="w" v-model="createAlbum.type">
                    <span>{{q}}</span>
                  </label>
                </div>
              </div>
            </div>-->
              <div class="form-group row align-items-center">
                <label
                  class="
                    col-md-2 col-sm-12 col-form-label
                    form-control-sm
                    text-right
                  "
                  >{{ $t("outside.相册权限：") }}</label
                >
                <div class="col-md-9 col-sm-12">
                  <div
                    class="form-check form-check-inline pd-r-15"
                    v-for="(s, k) in $dict.imgsStatus"
                    :key="k"
                  >
                    <label class="rdiobox">
                      <input
                        type="radio"
                        name="status"
                        :value="k"
                        v-model="createAlbum.status"
                      />
                      <span>{{ $t(s) }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer d-block pd-y-15 pd-x-0">
              <div
                class="
                  form-group
                  row
                  align-items-center
                  justify-content-end
                  pd-x-25
                  mg-b-0
                "
              >
                <button
                  type="button"
                  class="
                    mg-r-15
                    btn btn-primary
                    tx-11 tx-uppercase
                    pd-y-12 pd-x-25
                    tx-mont tx-semibold
                  "
                  @click="saveAlbum"
                >
                  {{ $t("outside.保存") }}
                </button>
                <button
                  type="button"
                  class="
                    btn btn-secondary
                    tx-11 tx-uppercase
                    pd-y-12 pd-x-25
                    tx-mont tx-semibold
                  "
                  @click="backUpload()"
                >
                  {{ $t("outside.返回") }}
                </button>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <albumSet :open="albumSetOpen" @start_pay="startPay"></albumSet>
    <PayMask :code="payCode" @pay_success="paySuccess"></PayMask>
  </div>
</template>

<script>
import albumSet from "./modal-album-set.vue";
import PayMask from "./pay-mask.vue"; //支付等待遮罩
export default {
  name: "uploadPic",
  props: ["open", "folder", "type", "num"],
  data() {
    return {
      //    maxSpace: this.$store.state.maxSpace,
      maxSpace: "",
      maxUpload:
        JSON.parse(localStorage.getItem("userInfo")) &&
        JSON.parse(localStorage.getItem("userInfo")).vipInfoJson &&
        JSON.parse(localStorage.getItem("userInfo")).vipInfoJson.albumInfo &&
        JSON.parse(localStorage.getItem("userInfo")).vipInfoJson.albumInfo
          .data &&
        JSON.parse(localStorage.getItem("userInfo")).vipInfoJson.albumInfo.data
          .folderSize
          ? JSON.parse(localStorage.getItem("userInfo")).vipInfoJson.albumInfo
              .data.folderSize
          : 0,
      modalLoading: false,
      loading: false,
      items: [],
      maxSize: 5 * 1024 * 1024, //最大字节数
      uploadFiles: [],
      round: 0,
      albumItems: [],
      selectedAlbum: "",
      usingSpace: 0, //已使用空间mb
      iis: 5,
      mode: 1, //1上传图片 2新建相册
      createAlbum: {
        name: "",
        type: 3,
        status: 1,
      },
      createAlbumDefault: "{}",
      uploadError: false,
      albumSetOpen: Symbol(),
      payCode: "",
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      uploadType: "",
      selectedId: "",
    };
  },
  components: {
    albumSet,
    PayMask,
  },
  computed: {
    successNum() {
      if (!this.uploadFiles) {
        return 0;
      }
      let len = 0;
      this.uploadFiles.forEach((file) => {
        if (file.success) {
          len++;
        }
      });
      return len;
    },
    errorFilesLen() {
      let len = 0;
      this.items.forEach((e) => {
        if (e.size > this.maxSize || !e.isImg)
          //图片要求
          len++;
      });
      return len;
    },
    imgLen() {
      let len = 0;
      this.items.forEach((e) => {
        if (e.size <= this.maxSize && e.isImg && e.checked)
          //图片要求
          len++;
      });
      return len;
    },
    totalSize() {
      let size = 0;
      this.items.forEach((e) => {
        if (e.size <= this.maxSize && e.isImg && e.checked)
          //图片要求
          size += e.size;
      });
      return (size / 1024 / 1024).toFixed(2);
    },
  },
  watch: {
    open() {
      this.modalLoading = false;
      this.loading = false;
      this.items = [];
      this.uploadFiles = [];
      this.round = 0;
      this.selectedAlbum = this.folder ? this.folder : "";
      this.createAlbum = JSON.parse(this.createAlbumDefault);
      this.uploadError = false;
      this.getAlbum();
      this.getSpace();
      if (this.userInfo.setSupplierAlbum == 1) {
        if (Number(this.userInfo.albumSize) == 0) {
          this.maxSpace = this.$t("outside.无限制");
        } else {
          this.maxSpace = Number(this.userInfo.albumSize) * 1024 + "MB";
        }
      } else {
        if (
          this.userInfo.vipInfoJson &&
          this.userInfo.vipInfoJson.albumInfo &&
          this.userInfo.vipInfoJson.albumInfo.data &&
          this.userInfo.vipInfoJson.albumInfo.data.size
        ) {
          this.maxSpace =
            Number(this.userInfo.vipInfoJson.albumInfo.data.size) * 1024 + "MB";
        } else {
          this.maxSpace = 0 + "MB";
        }
      }
    },
    selectedId() {
      if (this.selectedId) {
        this.albumItems.forEach((e) => {
          if (this.selectedId == e.id) {
            this.uploadType = e.type;
            this.selectedAlbum = e.name;
          }
        });
      } else {
        this.uploadType = 3;
      }
    },
    
  },
  mounted() {
    this.createAlbumDefault = JSON.stringify(this.createAlbum);
  },
  methods: {
    changeSelectAlbum() {
      if (this.selectedAlbum) {
        this.albumItems.forEach((e) => {
          if (e.selectedAlbum == e.name) {
            this.uploadType = e.type;
            this.selectedId = e.id;
          }
        });
      }
    },
    paySuccess(type) {
      if (type) {
        $.api_call("api.User.checkLoginStatus", { checkOverTime: 1 }, (r) => {
          if (r.ErrorCode == "9999") {
            location.reload();
          } else {
            userFailure(this);
          }
        });
      } else {
        location.reload();
      }
    },
    startPay(code) {
      this.payCode = code;
      //    this.payActive = true;
      $("#modalPayMask").modal("show");
      this.payMaskWait = setInterval(() => {
        $.api_call(
          "api.PayRecord.getStatus",
          {
            payCode: code,
          },
          (r) => {
            if (r.ErrorCode == "9999") {
              if (r.Data.Results == "2" || r.Data.Results == "4") {
                $.api_call(
                  "api.User.checkLoginStatus",
                  { checkOverTime: 1 },
                  (r) => {
                    if (r.ErrorCode == "9999") {
                      let DATA = r.Data.Results;
                      localStorage.setItem("apiUserToken", DATA.token);
                      localStorage.setItem("apiUserId", DATA.id);
                      localStorage.setItem(
                        "apiSubUserId",
                        DATA.subUserId ? DATA.subUserId : 0
                      );
                      store.set("userInfo", DATA);
                      store.set("isLogging", true);
                      sessionStorage.setItem("isApiSuccess", true);
                      location.reload();
                      clearInterval(this.payMaskWait);
                    } else {
                      userFailure(this);
                    }
                  }
                );
              }
            } else {
              if (r.ErrorCode == "1002") {
                userFailure(this);
              } else {
                ShowTip(r.Message, "danger");
              }
            }
          }
        );
      }, 3000);
    },
    openSet() {
      $("#modalUploadPic").modal("hide");
      this.albumSetOpen = Symbol();
      $(".modalUploadPic #modalAlbumSet").modal("show");
    },
    cancelUPload() {
      this.loading = false;
      this.uploadError = false;
      this.uploadFiles = [];
    },
    reUpload() {
      this.uploadError = false;
      this.loading = true;
      this.round = this.iis;
      for (let i = 0; i <= this.iis; i++) {
        this.upLoadApi(i);
      }
    },
    saveAlbum() {
      if (!this.createAlbum.name) {
        ShowTip(this.$t("outside.相册名不得为空"), "danger");
        return;
      }
      this.modalLoading = true;
      $.api_call(
        "api.SupplierAlbum.addBySupplier",
        {
          type: this.createAlbum.type,
          name: this.createAlbum.name,
          status: this.createAlbum.status,
        },
        (r) => {
          if (r.ErrorCode == "9999") {
            this.getAlbum();
            this.backUpload();
            this.$emit("createAlbum");
          } else {
            this.modalLoading = false;
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    backUpload() {
      this.mode = 1;
    },
    addAlbum() {
      this.createAlbum = JSON.parse(this.createAlbumDefault);
      this.mode = 2;
    },
    uploadSubmit() {
      //保存上传
      if (!this.selectedAlbum) {
        this.iis = 0;
        // ShowTip('请先选择要上传的相册', "danger");
        // return;
      }
      if (this.imgLen + this.num > this.maxUpload) {
        ShowTip(
          this.$t("outside.相册最多上传") +
            `${this.maxUpload}` +
            this.$t("outside.个文件"),
          "danger"
        );
        return false;
      }
      //重置上传数据
      this.uploadFiles = [];
      this.round = 0;
      this.items.forEach((img) => {
        if (img.checked && img.isImg && img.size <= this.maxSize) {
          //符合上传条件；
          this.uploadFiles.push({
            spu: this.selectedAlbum,
            file: img.file,
            fileName: img.name,
            size: img.size,
            success: false,
          });
        }
      });
      if (!this.uploadFiles.length) {
        ShowTip(this.$t("outside.没有符合上传条件的文件"), "danger");
        return;
      }
      if (Number(this.totalSize) + this.usingSpace > this.maxSpace) {
        ShowTip(this.$t("outside.您的空间不足"), "danger");
        return;
      }
      this.loading = true;
      this.round = this.iis;
      for (let i = 0; i <= this.iis; i++) {
        this.upLoadApi(i);
      }
    },
    upLoadApi(i) {
      if (this.uploadError) {
        return;
      }
      if (i > this.uploadFiles.length - 1) {
        return;
      }
      let fileItem = this.uploadFiles[i];
      if (fileItem.success) {
        this.round++;
        this.upLoadApi(this.round);
        return;
      }
      let reader = new FileReader();
      reader.readAsDataURL(fileItem.file);
      reader.onload = (e) => {
        fileItem.base64 = e.target.result;
        let params = {
          name: this.selectedAlbum,
          imgUrlBase64: fileItem.base64.split("base64,").pop(),
          ext: fileItem.fileName.split(".").pop(),
          size: fileItem.size,
          imgName: fileItem.fileName,
          type: this.uploadType ? this.uploadType : this.folder ? this.type : 3,
        };
        console.log(params);
        $.api_call("api.SupplierAlbum.uploadAlbum", params, (r) => {
          if (r.ErrorCode == "9999") {
            this.uploadType = params.type;
            this.selectedAlbum = r.Data.Results.name;
            fileItem.success = true;
            this.round++;
            if (this.round < this.uploadFiles.length) {
              this.upLoadApi(this.round);
            } else {
              //上传结束
              if (this.round - this.iis == this.uploadFiles.length) {
                this.loading = false;
                //上传成功结束模态框
                this.uploadFiles = [];
                this.$emit("uploadSuccess");
                ShowTip(this.$t("outside.上传成功"), "success");
                $("#modalUploadPic").modal("hide");
              }
            }
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else if (r.ErrorCode == "20200322") { // 图片尺寸不对时走的逻辑
              this.uploadError = true;
              ShowTip(r.Message, "danger");
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        });
      };
    },
    getSpace() {
      $.api_call("api.SupplierAlbum.getSizeByUser", {}, (r) => {
        if (r.ErrorCode == "9999") {
          this.usingSpace = r.Data.Results;
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    getAlbum() {
      //获取现有相册
      this.modalLoading = true;
      $.api_call("api.SupplierAlbum.findBySupplier", {}, (r) => {
        this.modalLoading = false;
        if (r.ErrorCode == "9999") {
          this.albumItems = r.Data.Results.datas;
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    fileChange(event) {
      let files = event.target.files;
      // let fileListMin = this.$refs.checkImg.files;
      if (!files.length) {
        ShowTip(this.$t("outside.没有可上传的文件"), "danger");
        return;
      }
      if (files.length + this.items.length > this.maxUpload) {
        ShowTip(
          this.$t("outside.一次最多处理") +
            `${this.maxUpload}` +
            this.$t("outside.个文件"),
          "danger"
        );
        return;
      }
      //       for(let i = 0; i < fileListMin.length; i++) {
      //   let reader = new FileReader();
      //   reader.readAsDataURL(fileListMin[i]);
      //   reader.onload = () => {
      //     let base64 = reader.result;
      //     let img = new Image();
      //     img.src = base64;
      //     img.onload = () => {
      //       if(img.width === img.height) {
      //         console.log(`第${i+1}张图片是正方形`);
      //       } else {
      //         console.log(`第${i+1}张图片不是正方形`);
      //       }
      //     }
      //   }
      // }
      //图片加入
      Object.keys(files).forEach((key) => {
        if (files[key].type != "") {
          console.log(files[key].width, 'files[key]');
          //只处理文件
          this.items.push({
            name: files[key].name,
            file: files[key],
            size: files[key].size,
            isImg: files[key].type.indexOf("image") > -1,
            checked:
              files[key].type.indexOf("image") > -1 &&
              files[key].size <= this.maxSize,
            key: files[key].name + files[key].siz,
          });
        }
      });
      //去重
      let hash = {};
      this.items = this.items.reduce((item, next) => {
        hash[next.key] ? "" : (hash[next.key] = true && item.push(next));
        return item;
      }, []);

      event.target.value = "";
    },
    uploadOpen() {
      document.getElementById("uploadPic").click();
    },
    toMb(size) {
      if (isNaN(size)) {
        return 0;
      }
      return (Number(size) / 1024 / 1024).toFixed(2);
    },
    resetModal() {
      this.items = [];
    },
  },
};
</script>

<style lang="less" scoped>
#uploadPic {
  display: none;
}
.upload-wrap {
  margin-bottom: 10px;
  padding: 15px;
  position: relative;
  border: 1px #ddd solid;
  height: 300px;
  overflow-y: auto;
  .upload-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .images-ul {
    list-style: none;
    margin: 0;
    padding: 0;
    > li {
      position: relative;
      height: 20px;
      line-height: 20px;
      color: #333;
      > label {
        display: flex;
        align-items: center;
        margin-bottom: 0;
      }
    }
    > li.disabled {
      color: #999;
      svg {
        opacity: 0.6;
      }
    }
  }
}
.name.tx-ellipsis1 {
  display: inline-block;
  max-width: 215px;
}
ol {
  list-style: none;
  margin: 0 0 20px 0;
  padding: 0 30px 0 0;
  border-bottom: 1px #ddd dashed;
  li {
    margin-bottom: 15px;
    color: #333;
    h3 {
      color: #666;
      font-size: 14px;
    }
    p {
      margin-bottom: 2px;
    }
  }
}
.p-bar {
  p {
    margin-bottom: 2px;
  }
  .bar {
    display: flex;
    justify-content: center;
    position: relative;
    width: 200px;
    border: 1px #17a2b8 solid;
    overflow: hidden;
    span {
      position: relative;
      z-index: 1;
      color: #000;
    }
    > .bg {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      background-color: #17a2b8;
    }
  }
}
.upload-loading-mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
  background: rgba(255, 255, 255, 0.4);
  .upload-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .upload-bar {
      background-color: #fff;
      padding: 25px;
      box-shadow: 1px 1px 6px #ddd;
      .bar {
        position: relative;
        margin-bottom: 15px;
        width: 460px;
        border: 1px #17a2b8 solid;
        > .text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #333;
        }
        > .bg {
          height: 22px;
          background-color: #17a2b8;
        }
      }
      p {
        margin: 0;
        text-align: center;
        color: #333;
      }
    }
  }
}
.back-upload {
  border: none;
  color: #999;
  background-color: transparent;
  cursor: pointer;
}
</style>